import { Box, Container, Grid, Typography, Stack, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { NavLogo } from '@/components/navbar/NavLogo';

const footerSections = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '/', hash: '#features' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Changelog', href: '#' },
      { label: 'Roadmap', href: '#' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Blog', href: '#' },
      { label: 'Careers', href: '#' },
      { label: 'Contact', href: '#' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Service', href: '#' },
      { label: 'POPIA Notice', href: '#' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Help Center', href: '#' },
      { label: 'API Docs', href: '#' },
      { label: 'Status Page', href: '#' },
    ],
  },
];

export function PublicFooter() {
  return (
    <Box component="footer" sx={{ py: 8, bgcolor: '#020208', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Box sx={{ mb: 2 }}>
              <NavLogo height={24} />
            </Box>
            <Typography variant="body2" sx={{ color: '#a0a5b5', lineHeight: 1.6, maxWidth: 280, mt: 1 }}>
              Modern HR management for South African employers. Built for SA labour law.
            </Typography>
          </Grid>

          {footerSections.map((section) => (
            <Grid size={{ xs: 6, sm: 3, md: 2 }} key={section.title}>
              <Typography sx={{ fontWeight: 600, color: '#f0f0f5', mb: 2, fontSize: 14 }}>
                {section.title}
              </Typography>
              <Stack spacing={1.5}>
                {section.links.map((link) =>
                  link.href.startsWith('#') ? (
                    <MuiLink
                      key={link.label}
                      href={link.href}
                      sx={{ color: '#a0a5b5', fontSize: 14, textDecoration: 'none', '&:hover': { color: '#f0f0f5' } }}
                    >
                      {link.label}
                    </MuiLink>
                  ) : (
                    <Box
                      key={link.label}
                      component={Link}
                      to={link.href}
                      sx={{ color: '#a0a5b5', fontSize: 14, textDecoration: 'none', '&:hover': { color: '#f0f0f5' } }}
                    >
                      {link.label}
                    </Box>
                  )
                )}
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.06)', mt: 6, pt: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography sx={{ color: '#6b7280', fontSize: 13 }}>
            © {new Date().getFullYear()} Rosta. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2}>
            {['Twitter', 'LinkedIn', 'GitHub'].map((social) => (
              <MuiLink
                key={social}
                href="#"
                sx={{ color: '#6b7280', fontSize: 13, textDecoration: 'none', '&:hover': { color: '#a0a5b5' } }}
              >
                {social}
              </MuiLink>
            ))}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
